import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'reimbursment_simulator/App.tsx'

const element = document.getElementById('reimbursment_simulator')
const root = createRoot(element)
root.render(<App />)
